import { App } from 'ionic-angular';
import { AppLoadingService } from '../../modules/core/services/app-loading-service/app-loading-service';
import { CampaignServiceProvider } from '../../modules/ranking/services/campaign-service/campaign-service';
import { ConfigServiceProvider } from '../../modules/core/services/config-service/config-service';
import { ENVIRONMENT } from '../../../environments/environment';
import { FilterServiceProvider, FilterType } from '../../modules/core/services/filter-service/FilterServiceProvider';
import { Injectable } from '@angular/core';
import { PlatformService } from '../../modules/core/services/platform-service/platform-service';
import { RankingServiceProvider } from '../../modules/ranking/services/ranking-service/ranking-service';
import { StorageServiceProvider } from '../../modules/core/services/storage-service/storage-service';
import { ProcessWrapperService } from '../../modules/core/services/process-wrapper-service/process-wrapper.service';
import { TenantService } from '../../modules/core/services/tenant-service/tenant.service';
import { UserTaskService } from '../../modules/user-tasks/services/user-task.service/user-task.service';

@Injectable()
export class LogoutService {
  constructor(
    private app: App,
    private campaignService: CampaignServiceProvider,
    private configService: ConfigServiceProvider,
    private filterService: FilterServiceProvider,
    private platformService: PlatformService,
    private rankingService: RankingServiceProvider,
    private storageService: StorageServiceProvider,
    private appLoaded: AppLoadingService,
    private processService: ProcessWrapperService,
    private tenantService: TenantService,
    private userTaskService: UserTaskService,
  ) {}

  public logout() {
    let isMobile = this.platformService.isMobile();
    if (isMobile) {
      this.logoutFromMobileApp();
    } else {
      this.logoutFromWebApplication();
    }
  }

  private logoutFromMobileApp() {
    this.resetTokensAndFilters().then(() => {
      this.app
        .getActiveNavs()[0]
        .push('LoginPage')
        .then(() => this.app.getRootNavs()[0].popToRoot())
        .catch((err) => console.error(err));
    });
  }

  private logoutFromWebApplication() {
    this.storageService.get('idToken').then((idToken) => {
      const logoutUrl =
        ENVIRONMENT.realmUrl.replace('{tenant}', this.tenantService.getTenant()) +
        '/protocol/openid-connect/logout' +
        '?post_logout_redirect_uri=' +
        encodeURIComponent(ENVIRONMENT.authLoginRedirect.replace('?tenant={tenant}', '')) +
        '&id_token_hint=' +
        encodeURIComponent(idToken);

      this.resetTokensAndFilters().then(() =>
        setTimeout(() => {
          window.location.href = logoutUrl;
        }, 500),
      );
    });
  }

  private async resetTokensAndFilters(): Promise<void> {
    try {
      await this.storageService.set('accessToken', null);
      await this.campaignService.resetPlayerCampaigns();
      await this.storageService.set('idToken', null);
      await this.storageService.set('refreshToken', null);
      await this.rankingService.setFilters(null);
      await this.rankingService.setGroupFilters(null);
      await this.rankingService.setHistoryFilters(null);
      await this.filterService.setFilter(FilterType.CLIENTS, this.filterService.defaultFilter);
      await this.filterService.setFilter(FilterType.CALENDAR, this.filterService.defaultFilter);
      await this.storageService.flushCache();
      this.processService.removeUserData();
      this.userTaskService.removeUserData();
      this.appLoaded.setStatus(false);
    } catch (error) {
      console.log(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/logout.service.ts